<template>
  <div>
       <a-modal title="导入数据" :visible="importVisible" @cancel="closeVisible" @ok="addFile" :footer="false" width="40%">
           <div class="top">
               <a-icon type="info-circle" style="color:#1890FF;margin-right: 5px;"/>
               <span>请选进行预算分解，下载模板并填写后再上传Excel文件</span>
           </div>
           <div class="bottom">
               <div class="box">
                   <span>步骤一：</span>
                   <div>
                      <a-button style="color:#1890FF;" type="link"  @click="download"> 点击下载Execl模板 </a-button>
                   </div>
               </div>
               <div class="box">
                   <span>步骤二：</span>
                   <div class="fileBox">
                       <a-upload-dragger
                       v-if="importVisible"
                            name="file"
                            :headers="headers"
                            method="post"
                            :data="upInfo"
                            :multiple="true"
                            :action="url"
                            @change="handleChange"
                            :beforeUpload="beforeUpload"
                            @preview="previewFile"
                            :remove="removeFile"
                        >
                            <p class="ant-upload-drag-icon">
                            <a-icon type="folder" />
                            </p>
                            <p class="ant-upload-text">
                              点击或将文件拖拽到这里上传
                            </p>
                            <p class="ant-upload-hint">
                            支持扩展名：.Excel
                            </p>
                        </a-upload-dragger>
                   </div>
               </div>

           </div>
       </a-modal>
  </div>
</template>

<script>
import store from '@/store'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { LOADING } from '@/store/modules/app'
import { downLoadXlxs2 } from '@/utils/index'
export default {
    data() {
        return {
            fileList: [],
            flag: false,
            file: '',
            importVisible: false,
            rowData: {},
		    upInfo: {},
            url: process.env.VUE_APP_API_BASE_URL + '/act/budget/upload'
        }
    },
    methods: {
        // 删除文件
        removeFile(file) {
            // console.log(file, 'file=======================')
			// 	let data = file.response.data + ',' + file.name
			// 	this.fileList.forEach((item, idx) => {
			// 		if (item == data) {
			// 			this.fileList.splice(idx, 1)
            //             this.$message.success('删除成功')
			// 		}
			// 	})
				
					
			},
        
        //预览文件
        previewFile(file) {
            window.open(file.response.data.url[0].url)
        },
            // 上传各式限制
			beforeUpload(file) {
                this.$store.commit('LOADING', true)
				console.log(file,'file====================')
				const tok = storage.get(ACCESS_TOKEN)
				this.headers = {
					token: tok,
				}
				this.upInfo = {
                    budgetId: this.rowData.id,
                    flag:this.flag,
					// delFlag: 2,
					// path: 'company' + this.$store.state.user.info.deptId + '/',
				}
				var isType = true
				const isLt2M = file.size / 1024 / 1024 < 30
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 30MB!')
					this.removeFile(file)
				}
                console.log(file, 'file111111111111111111111============================')
                if (file.name.indexOf('.xlsx') == -1) {
                    // this.removeFile(file)
                    this.$message.error("仅支持上传.xlsx格式的文件");
                    }
				return isLt2M && isType
			},
        init(data) {
             if(data.rowData.child_budget_dimension == '各单据模板（费用类型）') {
                this.flag = false
                } else {
                this.flag = true
                }
            this.rowData = data.rowData
            this.importVisible = true

        },
        closeVisible() {
             this.importVisible = false

        },
        addFile() {
            this.importVisible = false
            this.$emit('countDetail')
        },
        //下载
        download() {
             this.$store.commit('LOADING', true)
            if(this.rowData.child_budget_dimension == '各单据模板（费用类型）') {
                this.flag = false
                } else {
                this.flag = true
                }
                downLoadXlxs2(process.env.VUE_APP_API_BASE_URL + '/act/budget/download',
            {
                id: this.rowData.id,
                flag: this.flag,
            })
            this.$store.commit('LOADING', false)

        },
        handleChange(info) {
            console.log(info, 'info===================')
        //    if (info.file.status !== 'uploading') {
		// 			// info.fileList.splice(info.fileList.length - 1, 1)
		// 		}
				if (info.file.status === 'done') {
					if (info.file.response.code != 200) {
						info.fileList.forEach((item, idx) => {
							if (item.uid == info.file.uid) {
								info.fileList.splice(idx, 1)
							}
						})
						this.$message.error(info.file.response.msg)
						return
					}
                    if(info.fileList.length > 1) {
                        this.$message.warning('只能上一份文件！')
                        info.fileList.splice(1, 1)
                        return
                    }
						// this.$emit('getBillAttach', info.file.response.data.url[0])
                    this.addFile()
					this.$message.success('上传成功')
					// this.fileList.push(info.file.response.data.url[0].path)
				} else if (info.file.status === 'error') {
					this.$message.error('上传失败')
				}
                 this.$store.commit('LOADING', false)
                 this.$forceUpdate()
        },
    }

}
</script>

<style lang="less" scoped>
.top {
    height: 65px;
    margin: 0 15px;
    background-color: #D4E3FC;
    text-align: center;
    line-height: 65px;
    color: black;
    border-radius: 5px;
}
.bottom {
    margin: 10px 15px;
    color: black;
    .box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        span {
            width: 10%;
            margin-right: 5px;
            }  
        div {
             width: 85%;

        }
        
    }

}

</style>